import { Controller } from "@hotwired/stimulus";

// Opens a list-modal by key. Paired with list_modal_controller: the trigger
// and the modal live in different parts of the page, so they talk through a
// document-level event rather than a global function.
export default class extends Controller {
  static values = { key: String };

  open(event) {
    event.preventDefault();
    this.dispatch("open", { target: document, detail: { key: this.keyValue } });
  }
}
